<template>
  <div></div>
</template>

<script lang="ts" src="./html-textarea.component.ts" />
